import type { ReactNode } from 'react'
import type { TableListColumn } from '@/components/common/tableList/TableList'
import {
  TABLE_COL_ACTIVE_STATUS,
  TABLE_COL_DATETIME,
  TABLE_COL_ON_OFF_ACTION,
} from '@/components/common/tableList/tableListSizing'
import { tableActionsColDims } from '@/components/common/tableList/tableActionsColumn'

/**
 * Meta cột base dùng chung toàn project:
 * - Checkbox / STT: `TABLE_LEADING_WIDTHS` / `tableLeadingColDims`
 * - Ngày tạo / Ngày cập nhật: `TABLE_COL_DATETIME`, căn trái
 * - Trạng thái: `TABLE_COL_ACTIVE_STATUS`, căn giữa
 * - Bật tắt: `TABLE_COL_ON_OFF_ACTION`, căn giữa
 * - Thao tác (xem/sửa/xóa): `tableActionsColDims(iconCount)`, căn giữa
 */

export const TABLE_LIST_META_DATETIME_COL = {
  ...TABLE_COL_DATETIME,
  align: 'left' as const,
  headerAlign: 'left' as const,
}

export const TABLE_LIST_META_STATUS_COL = {
  ...TABLE_COL_ACTIVE_STATUS,
  align: 'center' as const,
  headerAlign: 'center' as const,
}

export const TABLE_LIST_META_ON_OFF_COL = {
  ...TABLE_COL_ON_OFF_ACTION,
  align: 'center' as const,
  headerAlign: 'center' as const,
}

export function tableListMetaCreatedAtCol(title: ReactNode, key = 'createdAt'): TableListColumn {
  return { key, title, ...TABLE_LIST_META_DATETIME_COL }
}

export function tableListMetaUpdatedAtCol(title: ReactNode, key = 'updatedAt'): TableListColumn {
  return { key, title, ...TABLE_LIST_META_DATETIME_COL }
}

export function tableListMetaStatusCol(title: ReactNode, key = 'status'): TableListColumn {
  return { key, title, ...TABLE_LIST_META_STATUS_COL }
}

export function tableListMetaOnOffCol(title: ReactNode, key = 'onOff'): TableListColumn {
  return { key, title, ...TABLE_LIST_META_ON_OFF_COL }
}

/** Cột thao tác xem/sửa/xóa (+ optional extras). */
export function tableListMetaActionsCol(
  title: ReactNode,
  iconCount: number,
  key = 'actions',
): TableListColumn {
  return {
    key,
    title,
    ...tableActionsColDims(iconCount),
    align: 'center',
    headerAlign: 'center',
  }
}
